import { useFetch } from 'app/queryProvider';
import { TDataFreshness } from '../entities';

export const useDataFreshness = (pathwayId?: string, options?: { enabled?: boolean }) => {
  return useFetch<TDataFreshness>({
    queryKey: [['pathway', 'data-freshness', pathwayId ?? '']],
    url: '/data-freshness',
    resource: { name: 'pathways', id: pathwayId },
    options: {
      enabled: (options?.enabled ?? true) && !!pathwayId,
    },
  });
};
